import { render, staticRenderFns } from "./lisShow.vue?vue&type=template&id=8965f64e&scoped=true"
import script from "./lisShow.vue?vue&type=script&lang=js"
export * from "./lisShow.vue?vue&type=script&lang=js"
import style0 from "./lisShow.vue?vue&type=style&index=0&id=8965f64e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8965f64e",
  null
  
)

export default component.exports